"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguage = void 0;
exports.getLanguage = function (dataLang, userLang) {
    return dataLang === 'userLang' ? userLang : dataLang;
};
//# sourceMappingURL=utils.js.map